
<div class="container reset_password_container">
    <div class="reset_password__inner_container">
        <h1 class="reset_pass_header">Reset Password.</h1>
        <p  class="reset_pass_header2">Fill in the details and login again with your new password.</p>
        <div class="reset_password_wrapper">
            <form role="form">
                <div class="form-group col-md-10" style="padding: 0;">
                    <input class="form-control" id="email" name="email" placeholder="Email *" type="email" [ngModel]="reset.email" (ngModelChange)="changeResetEmail($event)">
                </div>
                <div class="form-group col-md-10" style="padding: 0;">
                    <input class="form-control" id="password" name="password" placeholder="Password *" type="password" [ngModel]="reset.password" (ngModelChange)="changeResetPassword($event)">
                </div>
                <div class="form-group col-md-10" style="padding: 0;">
                    <input class="form-control" id="c_password" name="password_confirmation" placeholder="Confirm Password *" type="password" [ngModel]="reset.password_confirmation" (ngModelChange)="changeResetPasswordConfirmation($event)">
                </div>
                <div class="form-group col-md-10" style="padding: 0;">
                    <p (click)="resetPassword()" class="submitReset" type="submit" >Reset Password</p>
                </div>
                <div class="notification col-md-10" *ngIf="show_login_fail == true" >
                    <p class="notification_msg">Password not reset. Please try again or contact our sales team.</p>
                </div> 
                <div class="notification col-md-10" *ngIf="show_cpassword_fail == true" >
                    <p class="notification_msg">Passwords do not match. Please try again.</p>
                </div> 
            </form>
        </div>
    </div>
</div>
